import { createContext, ReactNode } from "react";

export type DialogContextType = {
  dialogs: ReactNode[];
  openDialog: (div: ReactNode) => void;
  closeDialog: () => void;
};

export const DialogContext = createContext<DialogContextType | undefined>(
  undefined,
);
